import { render, staticRenderFns } from "./LoaderRing.vue?vue&type=template&id=596e9c17&scoped=true&"
import script from "./LoaderRing.vue?vue&type=script&lang=js&"
export * from "./LoaderRing.vue?vue&type=script&lang=js&"
import style0 from "./LoaderRing.vue?vue&type=style&index=0&id=596e9c17&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "596e9c17",
  null
  
)

export default component.exports